import React, { useState, useEffect, useRef } from 'react';
// import SummaryListingComponent from "./SummaryListingComponent";
import PlusIcon from "./../../images/plus-rounded-14.svg";
import { Redirect } from 'react-router';
import { EDUCATION_LINK, FINAL_RESUME, HEADING_LINK, NEXT_EDUCATION_LABEL, NEXT_LABEL, NEXT_SUMMARY_LABEL, SKILLS_LINK, NEXT_SKILLS_LABEL, NEXT_WORKHISTORY_LABEL, WORKHISTORY_LINK, SKIP_CONFIRMATION_BOX_CONTENT, DELETE_CONFIRMATION_BOX_CONTENT, POPUP_TYPES, EDITOR_ALL_INONE_LINK, WORKHISTORY_TIPS_LINK, EDUCATION_TIPS_LINK } from '../../constants/constants';
//import PencilIcon from './../../images/pencil.svg';
import DeleteIcon from '../../assets/images-new/icons/bin-icon.svg';
import DraggableIcon from '../../assets/images/draggable-icon.svg';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import AddJob from './AddJob';
import QuickTips from '../common/QuickTips';
import { useResume } from '../../context/ResumeContext';
import { usePopup } from '../../context/PopupContext';
import { getExcerpt, removeBodyScroll, setBodyHeight } from '../../helper';
const Summary = (props) => {

    const emptyjob = {
        job_title: "",
        employer: "",
        city: "",
        state: "",
        start_date: "",
        end_date: "",
        currently_working: false,
        description: "",
      }
    const {
        resume: {
            heading: { fname },//Used to intentify component is ignored with first call with initial-data, and react with second time component is called with user input data
            work_history,
            enabled_tabs,
            skipped_sections
        },
        handlers: {
            updateResumePreview,
            nuteralizeNextClick,
            nuteralizeBackClick
        },
        next_clicked,
        next_label,
        back_clicked,
        skip_clicked,
        toggleSkip
    } = useResume();
    const confirmbox = usePopup();
    const workhistory = work_history
    const errorStyle = { color: 'red', fontSize: '10px' }
    const [showToolTip, setShowToolTip] = useState(false);
    //Flag is Do Next redirect
    const [redirectNext, setredirectNext] = useState(false)
    //Flag is Do Back redirect
    const [redirectBack, setredirectBack] = useState(false)
    //Component asked to redirect, first validate
    const [callOnce, setcallOnce] = useState(false)
    const [skipSection, setSkipSection ] = useState(false)
    const [showNameInput, setShowNameInput] = useState(false)
    const[editName, setEditName] = useState(false)
    //Quick edit mode
    const QEM = enabled_tabs.includes('completed')
    const label = (l) => QEM ? NEXT_LABEL : l
    const rURL = (u) => QEM ? FINAL_RESUME : u
    const section_key = 'work_history';
    const skipped = skipped_sections?.includes('work_history')

    const nextClicked = () => {
        if(skip_clicked){
            return toggleSkip('work_history')
        } else if (next_clicked ) {//Set for next page
            const blk = checkBlankSection()
            if(blk && !skipped) {
                confirmbox.show('section_skip',null,() => {
                    toggleSkip('work_history');
                    setredirectNext(true)

                        })
                nuteralizeNextClick({ next_label: label(NEXT_LABEL)  })
                return false
            }else{
                nuteralizeNextClick(
                { next_label: label(NEXT_LABEL)
                    , skip_label: skipped?'Add':'Skip'  }, true, QEM ? '' : 'education')
                return true
            }
            
        } else {//Set for own page
            //if (next_clicked || next_label != label(NEXT_EDUCATION_LABEL)) {
           // if (next_clicked) {
                //Always run for next click and self label not matched
                nuteralizeNextClick({ next_label: label(NEXT_LABEL), skip_label: skipped?'Add':'Skip'  })
                return false
           // }
        }
    }
    const backClicked = () => {
        if (back_clicked) {
            nuteralizeBackClick({ next_label: label(NEXT_LABEL) })
            return true
        }
    }
    const checkBlankSection = () => {
        let ids = Object.keys(workhistory.jobs)
        let secblank = null
        if (ids.length == 1) {
            ids.forEach(ele => {
                const job = workhistory.jobs[ele].job
                secblank = !(
                    job.job_title.trim().length ||
                    job.employer.trim().length ||
                    job.start_date.trim().length ||
                    (job.description.trim().length && job.description.trim() != '<p><br></p>')
                )
            })
        }
        return secblank;
    }
    useEffect(() => {
        if (nextClicked()) setredirectNext(true)
        else setredirectNext(false)
        if (backClicked()) setredirectBack(true)
        else setredirectBack(false)

        setcallOnce(false)
    }, [callOnce,fname]);
    // nextClicked() 
    useEffect(() => {
        setSkipSection(skipped_sections?.includes('work_history'))
    }, [skipSection, skipped_sections]);
    useEffect(() => {
        confirmbox.configurePopup(POPUP_TYPES);
    }, []);
    const onDragEnd = result => {
        // TODO: reorder our column
        const { destination, source, draggableId } = result;
        if (!destination) return
        if (destination.droppableId === source.droppableId && destination.index === source.index) return
        let ids = Object.keys(workhistory.jobs), jobs = {}
        ids.splice(source.index, 1)
        ids.splice(destination.index, 0, draggableId)
        ids.forEach(element => jobs[element] = { ...workhistory.jobs[element] })
        updateResumePreview(
            {
                work_history:
                {
                    ...work_history,
                    jobs: { ...jobs },
                    edit_in_progress: workhistory.edit_in_progress
                },
                current_tab: 'work_history'
            }
        )
    }
    const updateJob = (input, id) => {
        const job = {
            [id]: {//example job_1
                job: {
                    ...workhistory.jobs[id].job,
                    ...input
                }
            }
        }
        updateResumePreview(
            {
                current_tab: 'work_history',
                work_history:
                {
                    ...work_history,
                    jobs: {
                        ...workhistory.jobs,
                        ...job
                    },
                    edit_in_progress: workhistory.edit_in_progress
                }

            }
        )
    }
    const addJob = () => {
        const id = 'job_' + Math.floor(Math.random() * 1000)
        updateResumePreview(
            {
                current_tab: 'work_history',
                work_history:
                {
                    ...work_history,
                    jobs: {
                        ...workhistory.jobs,
                        [id]: { job:{...emptyjob} }
                    },
                    edit_in_progress: { job: id, step: 1 }
                }
            }
        )
        
    }
    const deleteJob = (id) => {
        if (workhistory.jobs.hasOwnProperty(id)) {
            let t = workhistory.jobs
            let prgs = workhistory.edit_in_progress
            delete t[id]
            if (!Object.keys(t).length) {//Last need to handle with default settings
                t = {job_1:{job:{...emptyjob} }}
                prgs = { job: 'job_1', step: 1 }
            }
            updateResumePreview(
                {
                    current_tab: 'work_history',
                    work_history:
                    {
                        ...work_history,
                        jobs: { ...t },
                        edit_in_progress: { ...prgs }
                    }

                }
            )
        }
    }
    const nextStep = (id, step) => {
        updateResumePreview(
            {
                current_tab: 'work_history',
                work_history:
                {
                    ...work_history,
                    jobs: workhistory.jobs,
                    edit_in_progress: { job: id, step: step }
                }
            }
        )
    }
    //let toci = false;
    const showTabOpenCloseIcon = () => (
        props.hasOwnProperty('tabOpened') ?
            <span className="open-close-btn red" onClick={() => {
                props.tabClicked('work_history', false);
                setShowNameInput(false);
                setBodyHeight();
            }}>
                {props.tabOpened ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
            </span> : ''
    ) 

    //Keep the control on multiple rendering and out of limit. Force to update once
    if ((next_clicked || back_clicked) && !callOnce) setcallOnce(true);
    if (redirectNext) { history.pushState(null, WORKHISTORY_LINK); return <Redirect to={rURL(EDUCATION_TIPS_LINK)} /> }
    if (redirectBack) return <Redirect to={rURL(WORKHISTORY_TIPS_LINK)} />

    return (
        <div className="editor-block-inner">
            {props.splash}
            <div className="editor-area red-line">
                <div className="form-heading">
                    <div className={`on-off-btn ${skipSection?'disabled':'red' }`} onClick={e => skipped ? toggleSkip('work_history') : confirmbox.show('section_skip',null,() => toggleSkip('work_history'))}>
                        <span><i></i></span></div>
                    {props.hasOwnProperty('tabClicked') 
                    ? <><div className="heading" onClick={() => {
                            if(!showNameInput){
                            props.tabClicked('work_hostory', editName);
                            setEditName(false);
                            }
                        }}>
                            {showNameInput 
                            ? '' 
                            : <>
                                <h1>
                                    {workhistory.name ?? `Professional Details`} {
                                        props?.tabOpened && props.tabOpened 
                                        ? <i className="icon-pencil" onMouseOver={() => setEditName(true)} onClick={() => {
                                        setShowNameInput(true);
                                        props.tabClicked('work_history', editName);
                                        }}></i>
                                        : ''
                                    }
                                </h1>
                            </>
                        }
                        {showNameInput 
                            ? <input
                                type="text"
                                className="edit-block-name"
                                name="name"
                                value={workhistory.name ?? `Professional Details`}
                                onChange={(e) => {
                                    props.tabClicked('work_history', true)
                                    updateResumePreview({ work_history: {...work_history, name: e.target.value }});
                                }}
                                onFocus={(e) => updateResumePreview({ work_history: {...work_history, name: e.target.value }})}
                                onBlur={(e) => {
                                    //fieldBlur(e);
                                    updateResumePreview({ work_history: {...work_history, name: e.target.value }})
                                    setShowNameInput(false)
                                }}
                            />
                            : '' 
                        }
                        <p>Add your past roles and let AI help refine your descriptions to highlight your achievements.</p>
                    </div></>
                    : <div className="heading" style={{cursor: "default"}}>
                            <h1>{workhistory.name ?? `Professional Details`}</h1>
                            <p>Add your past roles and let AI help refine your descriptions to highlight your achievements.</p>
                        </div>
                    }
                    {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="quick-tips red">
                        <span
                            onClick={() => {
                                setShowToolTip(!showToolTip);
                            }}><i className="icon-lightbulb-on"></i>Quick Tips</span>{showToolTip ? <QuickTips section='work_history' setShowToolTip={(showToolTip) => { setShowToolTip(showToolTip) }} /> : ''}</div>}
                    {showTabOpenCloseIcon()}
        </div>

        {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <DragDropContext onDragEnd={onDragEnd}>
                    <div className="summary-listing-wrapper">
                <Droppable droppableId={'unrelavent'} >
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {Object.keys(workhistory.jobs).map((job_id, index) => {
                                const job = workhistory.jobs[job_id].job
                                return (
                                    <Draggable draggableId={job_id} index={index} key={job_id}>
                                        {(provided, snapshot) => (
                                            <div 
                                            className= {`summary-listing-row${workhistory.edit_in_progress.job == job_id ? '' : ` row-closed`}`}
                                                {...provided.draggableProps}
                                                ref={provided.innerRef}
                                                key={job_id}
                                                // onClick={(e) => {
                                                //     if (['svg', 'path'].indexOf(e.target.tagName) == -1) {
                                                //         props.nextStep(job_id, 1), gaTrack('RT App', `Editor: Work Experience`, `Edit`); ga4Track('app_editor_experience_pencil_icon', 'RT App', 'Edit');
                                                //     }
                                                // }
                                                // }
                                                >
                                                <div className="row">
                                                    <div className="reorder">
                                                        <div type="button" className="btn btn-link" dataid={job_id} {...provided.dragHandleProps}><DraggableIcon /></div>
                                                    </div>
                                                    <div className="block-details">
                                                    <h2 data-index={index + 1}><strong>{`${job.job_title}${job.employer && `, ${job.employer}`}`}</strong>
                                                        {job.start_date ? ' | ' + job.start_date : ' '}
                                                        {job.start_date ?
                                                            (job.currently_working ? ` - Present` : ` ${job.end_date ? ' - ' + job.end_date : ''}`) :
                                                            (job.currently_working ? ` | Present` : ` ${job.end_date ? ' | ' + job.end_date : ''}`)
                                                        }</h2>
                                                        {workhistory.edit_in_progress?.job == job_id ? <p>&nbsp;</p> : <div className="desc" dangerouslySetInnerHTML={{ __html: getExcerpt(job.description)}} />}
                                                    </div>
                                                    <div className="btn-group">

                                                        <button type="button" className="dd-btn" onClick={(e) => {
                                                            if(workhistory.edit_in_progress.job == job_id) nextStep('', null); 
                                                            else nextStep(job_id, 1); 
                                                             gaTrack('RT App', `Editor: Work Experience`, `Edit`); 
                                                             ga4Track('app_editor_experience_pencil_icon', 'RT App', 'Edit'); }} dataid={job_id}>
                                                            {workhistory.edit_in_progress.job == job_id ? <i className="icon-chevron-left"></i> : <i className="icon-right-arrow"></i>}
                                                        </button>
                                                        <button type="button" className="btn btn-link " onClick={(e) => {
                                                            confirmbox.show('row_delete',null, ()=>{
                                                                deleteJob(job_id);
                                                                gaTrack('RT App', `Editor: Work Experience`, `Delete`); 
                                                                ga4Track('app_editor_experience_trash_icon', 'RT App', 'Delete');
                                                            })
                                                            removeBodyScroll(true);
                                                            // window.confirm(
                                                            //     "Are you sure to delete this work summary?"
                                                            // ) && deleteJob(job_id), gaTrack('RT App', `Editor: Work Experience`, `Delete`); ga4Track('app_editor_experience_trash_icon', 'RT App', 'Delete');
                                                        }} dataid={job_id}><DeleteIcon className="icon-blue" /></button>
                                                    </div>
                                                </div>
                                                {workhistory.edit_in_progress?.job == job_id ?
                                                <AddJob 
                                                    data={job}
                                                    id={job_id}
                                                    updateJob={updateJob}
                                                    enabled_tabs={enabled_tabs}
                                                /> :''}
                                            </div>)
                                        }
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                    </div>
                    <div className="add-more-btn-cover">
                    <button className="btn-link-style red" onClick={() => { addJob() }}><PlusIcon /> <span>Add Another Job </span></button>
                </div>
                </DragDropContext>}

            </div>
        </div>);
}

export default Summary;